import { TenantModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class TenantODataRepo extends BaseODataRepository<TenantModel> {
  protected baseUrl = `/OData/tenants`;
}
